module.exports = __webpack_public_path__ + "img/ico2.15bc6b28.png";